export * from './fetch-geo-data';
